import React from 'react';
import { Col, Row, Button } from 'reactstrap';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

const MatchingCauses = () => (

	<div style={{ overflow: 'hidden' }} >
		<p className="text-center matching-heading">Individual support can help the receiver in many ways</p>
		<Row className=" d-flex justify-content-center align-self-center">
			<Col xs="12" sm="12" md="6" lg="3" style={{ paddingTop: '16px;' }}>
				<Row className="">
					<Col className="p-0" xs="6" sm="6" md="6" lg="3" >
						<div className="flip-card">
							<div className="flip-card-inner">
								<div className="flip-card-front" >
									<img className="flip-images-matching" src={`${config.cdnUrl}/static/images/home/causes-children.jpg?w=300&q=50`} alt="Avatar" />
									<div className="matching-card-cause-text">Children</div>
								</div>
								<div className="flip-card-back d-flex justify-content-center align-self-center">
									<p className="d-flex justify-content-center align-self-center flip-card-back-text" > Help a poor child receive continued access to basic necessities like nutrition, healthcare, transport to school etc.</p>
								</div>
							</div>
						</div>
					</Col>
					<Col xs="6" sm="6" md="6" lg="3" className="hide-for-desktop p-0  justify-content-center align-self-center " >
						<p style={{ paddingLeft: '10px;' }}>Help a poor child receive continued access to basic necessities</p>
					</Col>
				</Row>
			</Col>
			<Col xs="12" sm="12" md="6" lg="3" style={{ paddingTop: '16px;' }} >
				<Row>
					<Col className="p-0" xs="6" sm="6" md="6" lg="3" >
						<div className="flip-card">
							<div className="flip-card-inner">
								<div className="flip-card-front" >
									<img className="flip-images-matching" src={`${config.cdnUrl}/static/images/home/causes-education.jpg?w=300&q=50`} alt="Avatar" />
									<div className="matching-card-cause-text">Education</div>
								</div>
								<div className="flip-card-back d-flex justify-content-center align-self-center">
									<p className="d-flex justify-content-center align-self-center flip-card-back-text"> Help a poor student with fees, school supplies or educational facilities to continue his or her education.</p>
								</div>
							</div>
						</div>
					</Col>
					<Col xs="6" sm="6" md="6" lg="3" className="hide-for-desktop  p-0  justify-content-center align-self-center " >
						<p style={{ paddingLeft: '10px;' }}>Help a poor student with fees, school supplies or educational facilities  </p>
					</Col>
				</Row>
			</Col>
			<Col xs="12" sm="12" md="6" lg="3" style={{ paddingTop: '16px;' }} >
				<Row >
					<Col className="p-0" xs="6" sm="6" md="6" lg="3" >
						<div className="flip-card">
							<div className="flip-card-inner">
								<div className="flip-card-front">
									<img className="flip-images-matching" src={`${config.cdnUrl}/static/images/home/causes-elderly.jpg?w=300&q=50`} alt="Avatar" />
									<div className="matching-card-cause-text">Elderly</div>
								</div>
								<div className="flip-card-back d-flex justify-content-center align-self-center">
									<p className="d-flex justify-content-center align-self-center flip-card-back-text">Help a poor senior citizen receive continued access to basic necessities like food and shelter in their old age. </p>
								</div>
							</div>
						</div>
					</Col>
					<Col xs="6" sm="6" md="6" lg="3" className="hide-for-desktop  p-0  justify-content-center align-self-center" >
						<p style={{ paddingLeft: '10px;' }} >Help a poor senior citizen receive continued access to basic necessities </p>
					</Col>
				</Row>
			</Col>
			<Col xs="12" sm="12" md="6" lg="3" style={{ paddingTop: '16px;' }} >
				<Row >
					<Col className="p-0" xs="6" sm="6" md="6" lg="3">
						<div className="flip-card">
							<div className="flip-card-inner">
								<div className="flip-card-front">
									<img className="flip-images-matching" src={`${config.cdnUrl}/static/images/home/causes-health.jpg?w=300&q=50`} alt="Avatar" />
									<div className="matching-card-cause-text">Health</div>
								</div>
								<div className="flip-card-back d-flex justify-content-center align-self-center">
									<p className="d-flex justify-content-center align-self-center flip-card-back-text"> Help a poor patient with support for hospital costs, surgery costs, and medicines to receive proper medical care.</p>
								</div>
							</div>
						</div>
					</Col>
					<Col xs="6" sm="6" md="6" lg="3" className="hide-for-desktop  p-0  justify-content-center align-self-center " >
						<p style={{ paddingLeft: '10px;' }} >Help a poor patient with access to medical care and medicines</p>
					</Col>
				</Row>
			</Col>

		</Row>
		<div style={{ paddingTop: '3rem' }}>
			<center><a href="/search?tag=Individual%20Support&type=relevance" ><Button color="primary" className=" btn matching-button " type="submit" >  Meet The One </Button></a></center>
		</div>

		<style global jsx>
			{
				`

   .cause-text-mobile-matching{
		 padding-top: 20px;
	 }



				@media (max-width: 768px) {
					.flip-card:hover .flip-card-inner {
						transform: none!important;
					}
			}

				@media (max-width: 768px) {
			.flip-card{
				max-width: 100%;
				max-height: 100%;
				width: 150px!important;
				height: 150px!important;
				transform: none!important;
				object-fit: contain!important;

			}
			}
			@media (max-width: 768px) {
		.flip-card-back-text{
		display: none!important;

		}
		}

.flip-card-back-text{
	padding-left: 5px;
	padding-right: 5px;
}

				.matching-card-cause-text {
					margin: 0;
background: white;
display: inline-block;
padding: 5px 10px;
text-transform: capitalize;
font-size: 20px;
font-weight: 400;
    position: absolute;
    top: 80%;
    left: 50%;
    transform: translate(-50%, -50%);
}
				@media (max-width: 768px) {
			.flip-card{
				background-color: transparent;
				width: 100%;
				height: 200px;
			border-radius: 5px;
			overflow: hidden;
			}
			}

				@media (max-width: 768px) {
			.matching-card-cause{
		padding: 10px 0px 0px 0px;
		height: 165px!important;
			}
			}

			@media (max-width: 768px) {
		.flip-images-matching{
			width: 100%;
			height: 100%;
object-fit: fill!important;
		}
		}
		.matching-card-cause{
			width: 250px!important;
			height: 200px;
		}




.flip-card {
	background-color: transparent;
	width: 250px;
	height: 200px;
border-radius: 5px;
overflow: hidden;

}

.flip-card-inner {
	position: relative;
	width: 100%;
	height: 100%;
	text-align: center;
	transition: transform 0.8s;
	transform-style: preserve-3d;
}

.flip-card:hover .flip-card-inner {
	transform: rotateY(180deg);
}

.flip-card-front, .flip-card-back {
	position: absolute;
	width: 100%;
	height: 100%;
	backface-visibility: hidden;
}

.flip-card-front {
	background-color: #bbb;
	color: black;

}


.flip-card-back {
	background-color: #ff5050;
	color: white;
	transform: rotateY(180deg);
}
.flip-images-matching{
	width:100%;

}

.bottom-left {
		position: absolute;
		bottom: 8px;
		left: 16px;
		color: red;
}
				`
			}
		</style>
	</div>

);

export default MatchingCauses;
